<template>
  <el-dialog
    width="1200px"
    title="查看详情"
    :visible="dialogVisible"
    @close="close"
  >
    <ul class="info-list">
      <li class="mb20">
        <div class="title">基本信息</div>
        <div class="mb20">
          <el-table
            stripe
            border
            :data="[detMemberMgt.storeMemberCenterInfoVo]"
            size="small"
          >
            <el-table-column
              header-align="center"
              align="center"
              prop="memberName"
              label="姓名"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="memberMobile"
              label="手机号"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="memberSex"
              label="性别"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.memberSex === "male" ? "男" : "女" }}</span>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="memberBirthday"
              label="生日"
            ></el-table-column>
            <!-- <el-table-column
              header-align="center"
              align="center"
              prop="spuName"
              label="星座"
            ></el-table-column> -->
            <el-table-column
              header-align="center"
              align="center"
              prop="nickName"
              label="微信昵称"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="subscribeTime"
              label="关注时间"
            ></el-table-column>
          </el-table>
        </div>
        <div class="mb20">
          <el-table
            stripe
            border
            :data="detMemberMgt.familyInfoVoList"
            size="small"
          >
            <el-table-column
              header-align="center"
              align="center"
              prop="familyRelation"
              label="成员关系"
            >
              <template slot-scope="scope">
                <span v-show="scope.row.familyRelation === 'son'">儿子</span>
                <span v-show="scope.row.familyRelation === 'daughter'"
                  >女儿</span
                >
                <span v-show="scope.row.familyRelation === '-'"></span>
                <span v-show="scope.row.isPredicted === 'yes'">孕期</span>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="familyName"
              label="姓名"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="familyBirthday"
              label="生日/预产期"
            ></el-table-column>
          </el-table>
        </div>
        <div class="mb20">
          <el-table
            stripe
            border
            :data="[detMemberMgt.storeMemberCenterInfoVo]"
            size="small"
          >
            <el-table-column
              header-align="center"
              align="center"
              prop="cardAddress"
              label="常用地址"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="shopName"
              label="归属门店"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="realName"
              label="归属导购"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.realName"
                  >{{ scope.row.shopName }}
                  {{ scope.row.shopName ? "-" : "" }}
                  {{ scope.row.realName }}</span
                >
                <div v-if="scope.row.workNum">
                  导购工号:{{ scope.row.workNum }}
                </div>
                <!-- <span
                    class="blue"
                    v-if="
                      scope.row.defaultCardId !== '-' && !scope.row.realName
                    "
                    @click="getEmployee(scope.row)"
                    >指定导购</span
                  > -->
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="来源方式"
              prop="sourceType"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.sourceType == 'manual'">手工</span>
                <span v-if="scope.row.sourceType == 'synchro'">同步</span>
                <span v-if="scope.row.sourceType == 'fans'">粉丝</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </li>
      <li class="mb20">
        <div class="title">会员卡信息</div>
        <div class="flex flex-center mb20">
          <div class="text-center">
            <div class="primary mb10">
              {{
                detMemberMgt.cardInfoVoList
                  ? detMemberMgt.cardInfoVoList.length
                  : 0
              }}
            </div>
            <div>会员卡数量</div>
          </div>
          <div class="line"></div>
          <div class="text-center pointer" @click="viewCustomerCoupon">
            <div class="primary mb10">{{ detMemberMgt.couponNum }}</div>
            <div>可用优惠券</div>
          </div>
          <div class="line"></div>
          <div class="text-center pointer" @click="viewCustomerJinDou">
            <div class="primary mb10">{{ totalGoldBeanAmount || 0 }}</div>
            <div>可用金豆</div>
          </div>
        </div>
        <el-table
          stripe
          border
          :data="detMemberMgt.cardInfoVoList"
          size="small"
        >
          <el-table-column
            header-align="center"
            align="center"
            prop="typeName"
            label="会员卡类型"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="cardNo"
            label="卡号"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="createTime"
            label="开卡时间"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="currentIntegral"
            label="积分"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="currentBalance"
            label="储值卡"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="totalConsumption"
            label="累计消费金额"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="firstOfflineShoppingAmount"
            label="首次消费金额"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="firstOfflineShoppingTime"
            label="首次消费时间"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="lastOfflineShoppingAmount"
            label="最后一次消费金额"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="lastOfflineShoppingTime"
            label="最后一次消费时间"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="cardState"
            label="卡状态"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.cardState == 'yes'" class="success"
                >正常</span
              >
              <span v-else class="danger">停用</span>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="isMasterCard"
            label="是否默认消费卡"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.isMasterCard == 'yes'" class="success"
                >是</span
              >
              <span v-else class="danger">否</span>
            </template>
          </el-table-column>
        </el-table>
        <div
          class="cardid"
          v-if="detMemberMgt.storeMemberCenterInfoVo.joinTime"
        >
          成为推会员时间：{{ detMemberMgt.storeMemberCenterInfoVo.joinTime }}
        </div>
        <div class="cardid">
          选择默认消费卡
          <el-radio
            v-model="defaultCardId"
            :label="v.memberCardId"
            v-for="(v, i) in detMemberMgt.cardInfoVoList"
            :key="i"
            >{{ v.typeName }}</el-radio
          >
        </div>
      </li>
      <li class="mb20">
        <div class="flex flex-wrap item-center">
          <div class="title mr10">标签信息</div>
          <el-button
            size="small"
            type="text"
            @click="addLabel"
            style="margin-bottom: 20px;"
            >增加标签</el-button
          >
        </div>

        <template v-for="(v, i) in detMemberMgt.labelInfoVos">
          <el-tag
            v-if="detMemberMgt.labelInfoVos.length"
            style="margin:5px"
            :key="i"
            :closable="v.labelType === 'manual'"
            @close="handleTagClose(v, i)"
          >
            {{ v.labelName }}</el-tag
          >
        </template>
      </li>
      <!-- <li class="mb20">
        <div class="title">交易统计</div>
        <el-table stripe border :data="[]" size="small">
          <el-table-column
            header-align="center"
            align="center"
            prop="spuName"
            label="最近下单时间"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="spuName"
            label="单客价"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="spuName"
            label="消费金额"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="spuName"
            label="消费订单（笔）"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="spuName"
            label="退款金额（元）"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="spuName"
            label="退款订单（笔）"
          ></el-table-column>
        </el-table>
      </li> -->
    </ul>
    <div class="btn-wrapper flex flex-center">
      <el-button size="small" type="primary" @click="save">确 定</el-button>
      <el-button size="small" @click="dialogVisible = false">取消</el-button>
      <el-button size="small" type="info" @click="logout">注 销</el-button>
    </div>
    <el-dialog
      width="30%"
      title="增加标签"
      :visible.sync="innerVisible"
      append-to-body
    >
      <div>
        会员标签：
        <el-select
          clearable
          class="mr10"
          style="width:200px"
          size="small"
          v-model="labelId"
          placeholder="请选择会员标签"
          filterable
        >
          <el-option
            :label="v.labelName"
            :value="v.labelId"
            :key="i"
            v-for="(v, i) in allLabelList"
          ></el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button size="small" type="primary" @click="saveLabel"
          >确 定</el-button
        >
        <el-button size="small" @click="innerVisible = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="客户优惠券"
      width="70%"
      append-to-body
      :close-on-click-modal="false"
      :visible.sync="couponDialogVisible"
    >
      <div class="mb20">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="可用券" name="valid"></el-tab-pane>
          <el-tab-pane label="失效券" name="invalid"></el-tab-pane>
        </el-tabs>
        <template v-if="activeName === 'valid'">
          <el-radio-group
            size="small"
            v-model="useRank"
            @change="switchCouponState"
          >
            <el-radio-button
              v-for="(v, i) in navList"
              :key="i"
              :label="v.useRank"
              >{{ v.text }}</el-radio-button
            >
          </el-radio-group>
        </template>
        <template v-if="activeName === 'invalid'">
          <el-radio-group
            size="small"
            v-model="couponState"
            @change="switchCouponState"
          >
            <el-radio-button
              v-for="(v, i) in validCouponNavList"
              :key="i"
              :label="v.couponState"
              >{{ v.text }}</el-radio-button
            >
          </el-radio-group>
        </template>
      </div>
      <el-table
        stripe
        border
        ref="brandTable"
        :data="couponList"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (couponCurrentPage - 1) * couponPageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="券名"
          prop="name"
        >
        </el-table-column>
        <el-table-column header-align="center" align="center" label="券额">
          <template slot-scope="scope">
            <span v-if="scope.row.account">￥{{ scope.row.account }}</span>
            <span v-if="scope.row.discount">{{ scope.row.discount }}折</span>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="使用门槛">
          <template slot-scope="scope"> ￥{{ scope.row.levelMin }} </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="过期时间"
          prop="endTime"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="备注"
          prop="ruleRemark"
        >
        </el-table-column>
      </el-table>
      <div class="hm-pagination mb20">
        <el-pagination
          background
          :total="couponTotal"
          @current-change="couponPaging"
          @size-change="handleCouponSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="couponCurrentPage"
          :page-size="couponPageSize"
        ></el-pagination>
      </div>
      <div class="flex flex-center">
        <el-button size="small" @click="couponDialogVisible = false"
          >关 闭</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="金豆明细"
      :visible.sync="dialogVisibleJinDou"
      width="1000px"
      append-to-body
    >
      <el-dialog
        :close-on-click-modal="false"
        title="调整金豆"
        :visible.sync="dialogVisibleEditJindou"
        width="500px"
        append-to-body
      >
        <div class="flex flex-center">
          <div class="text-center">
            <el-radio-group v-model="operateType">
              <el-radio label="add">新增</el-radio>
              <el-radio label="sub">扣减</el-radio>
            </el-radio-group>
            <div class="mt20">
              <el-input
                clearable
                v-model.trim="operateNum"
                placeholder="请输入金豆数"
                size="small"
                class="ipt"
              ></el-input>
              <div class="text-left">
                可用调整
                <span class="primary">{{
                  adjustJindouRow.goldBeanAmountBalance
                }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="btn-wrapper flex flex-center" slot="footer">
          <el-button size="small" type="primary" @click="editJinDou"
            >确 认</el-button
          >
          <el-button
            @click="dialogVisibleEditJindou = false"
            size="small"
            type="info"
            >取 消</el-button
          >
        </div>
      </el-dialog>
      <el-radio-group
        class="mb10"
        size="small"
        v-model="detailType"
        @change="detailTypeChange"
      >
        <el-radio-button label="data">金豆数据</el-radio-button>
        <el-radio-button label="biangeng">变更记录</el-radio-button>
      </el-radio-group>
      <div v-if="detailType === 'data'">
        <el-table
          :data="detailList"
          style="width: 100%"
          stripe
          size="small"
          border
          ref="jindoutable"
          max-height="500px"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="金豆别称"
            prop="ruleName"
          ></el-table-column>
          <el-table-column header-align="center" align="center" label="有效期" width="300">
            <template slot-scope="scope">
              {{ scope.row.startTime }} - {{ scope.row.endTime }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="金豆值"
            prop="goldBeanAmountBalance"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="useStatus"
            label="金豆状态"
          >
            <template slot-scope="scope">
              <div :class="scope.row.useStatus === 'yes' ? 'success' : 'danger'">
                {{ scope.row.useStatus === "yes" ? "开启" : "作废" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" header-align="center" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="adjustJindou(scope.row)"
              >
                调整金豆
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-else>
        <el-table
          :data="detailList"
          style="width: 100%"
          stripe
          size="small"
          border
          max-height="400px"
          ref="jindoutable"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            :index="
              index => index + (currentPageDetail - 1) * pageSizeDetail + 1
            "
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="变更操作"
            key="bizType"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.bizType === 'orderOffline'">
                线下下单获取
                <el-popover
                  placement="bottom"
                  width="200"
                  trigger="click"
                  :content="scope.row.content"
                >
                  <div slot="reference" class="blue pointer">获取名称</div>
                </el-popover>
              </div>
              <div v-else-if="scope.row.bizType === 'orderOnline'">
                线上下单获取
                <el-popover
                  placement="bottom"
                  width="200"
                  trigger="click"
                  :content="scope.row.content"
                >
                  <div slot="reference" class="blue pointer">获取名称</div>
                </el-popover>
              </div>
              <div v-else-if="scope.row.bizType === 'used'">
                购买消耗
              </div>
              <div v-else-if="scope.row.bizType === 'orderRefund'">
                线上订单退款返还
              </div>
              <div v-else-if="scope.row.bizType === 'orderOfflineRefund'">
                线下订单退款扣减
              </div>
              <div v-else-if="scope.row.bizType === 'orderTimeOut'">
                订单超时返还
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="交易订单号"
            prop="fromOrder"
          ></el-table-column>

          <el-table-column
            header-align="center"
            align="center"
            label="金豆别称"
            prop="ruleName"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="金豆变化"
            key="goldBeanAmount"
          >
            <template slot-scope="scope">
              <span> {{ scope.row.tradeModel === "in" ? "+ " : "- " }}</span>
              {{ scope.row.goldBeanAmount }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="变更时间"
            prop="createTime"
          ></el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="totalDetail"
            @current-change="pagingDetail"
            @size-change="handleSizeChangeDetail"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPageDetail"
          ></el-pagination>
        </div>
      </div>

      <div class="btn-wrapper flex flex-center" slot="footer">
        <el-button size="small" @click="dialogVisibleJinDou = false"
          >取 消</el-button
        >
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { getLoginUser } from "@/utils/auth";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    centerId: {
      type: String,
      default: ""
    }
  },
  components: {},
  data() {
    return {
      operateType: "add",
      operateNum: "",
      adjustJindouRow: {},
      dialogVisibleEditJindou: false,
      activeName: "valid",
      couponDialogVisible: false,
      detailList: [],
      dialogVisibleJinDou: false,
      searchConditionDialog: {},
      dialogVisible: this.visible,
      innerVisible: false,
      allLabelList: [],
      detMemberMgt: {
        storeMemberCenterInfoVo: [],
        cardInfoVoList: [],
        familyInfoVoList: [],
        labelInfoVos: []
      },
      labelId: "",
      defaultCardId: "",
      currentPageDetail: 1,
      pageSizeDetail: 10,
      totalDetail: 0,
      detailType: "data",
      totalGoldBeanAmount: 0,
      couponPageSize: 10,
      couponCurrentPage: 1,
      couponList: [],
      couponTotal: 0,
      useRank: 0,
      couponState: "",
      validCouponNavList: [
        {
          couponState: "notExpired",
          text: "已使用",
          loadingType: "more",
          couponList: []
        },
        {
          couponState: "expired",
          text: "已过期",
          loadingType: "more",
          couponList: []
        },
        {
          couponState: "freeze",
          text: "冻结中",
          loadingType: "more",
          couponList: []
        }
      ],
      navList: [
        {
          useRank: 0,
          text: "通用券",
          loadingType: "more",
          couponList: []
        },
        {
          useRank: 2,
          text: "门店券",
          loadingType: "more",
          couponList: []
        },
        {
          useRank: 1,
          text: "线上券",
          loadingType: "more",
          couponList: []
        }
      ]
    };
  },
  computed: {},
  watch: {
    centerId() {
      this.queryDetails();
      this.queryDetailList();
    },
    visible(val) {
      this.dialogVisible = val;
    }
  },
  created() {},
  mounted() {},
  methods: {
    adjustJindou(row) {
      this.operateType = "add";
      this.operateNum = "";
      this.adjustJindouRow = row;
      this.dialogVisibleEditJindou = true;
    },
    async editJinDou() {
      if (!this.operateNum) {
        this.$message({
          message: "请输入金豆数",
          type: "warning"
        });
        return;
      }
      await this.$store.dispatch("applyUpdateMemberGoldBeanNum", {
        centerId: this.adjustJindouRow.centerId,
        operateType: this.operateType,
        operateNum: this.operateNum,
        ruleId: this.adjustJindouRow.ruleId
      });
      this.$message({
        message: "操作成功！",
        type: "success"
      });
      this.dialogVisibleEditJindou = false;
    },
    handleClick() {
      this.couponList = [];
      this.couponCurrentPage = 1;
      if (this.activeName === "valid") {
        this.useRank = 0;
        this.queryCustomerCoupon();
      } else {
        this.couponState = "notExpired";
        this.queryCustomerCoupon();
      }
    },
    switchCouponState() {
      this.couponCurrentPage = 1;
      this.queryCustomerCoupon();
    },
    couponPaging(page) {
      this.couponCurrentPage = page;
      this.queryCustomerCoupon();
    },
    handleCouponSizeChange(size) {
      this.couponCurrentPage = 1;
      this.couponPageSize = size;
      this.queryCustomerCoupon();
    },
    viewCustomerCoupon() {
      this.activeName = "valid";
      this.useRank = 0;
      this.queryCustomerCoupon();
      this.couponDialogVisible = true;
    },
    async queryCustomerCoupon() {
      const { storeCode } = getLoginUser();
      const params = {
        memberCenterId: this.centerId,
        storeCode,
        pageSize: this.couponPageSize,
        pageNo: this.couponCurrentPage
      };
      if (this.activeName === "valid") {
        Object.assign(params, {
          type: "notexpired",
          status: "4",
          useRank: this.useRank
        });
      } else {
        if (this.couponState === "notExpired") {
          Object.assign(params, {
            status: "2",
            type: null
          });
        } else if (this.couponState === "expired") {
          Object.assign(params, {
            status: null,
            type: "expired"
          });
        } else if (this.couponState === "freeze") {
          Object.assign(params, {
            status: 5,
            type: null
          });
        }
      }
      const { result } = await this.$store.dispatch(
        "queryCustomerCoupon",
        params
      );
      const { page } = result;
      const { records, total } = page;
      this.couponTotal = total;
      const couponList = records;
      couponList.filter(item => {
        if (
          item.ruleStartDate &&
          item.ruleEndDate &&
          item.ruleStartTime &&
          item.ruleEndTime
        ) {
          item.dateTime =
            item.ruleStartDate +
            " " +
            item.ruleStartTime.split(",")[0] +
            "至" +
            item.ruleEndDate +
            " " +
            item.ruleEndTime.split(",")[0];
          item.endTime =
            item.ruleEndDate + " " + item.ruleEndTime.split(",")[0];
        } else {
          item.dateTime = "";
        }
      });
      this.couponList = couponList;
    },
    async handleTagClose(tag, index) {
      const { code } = await this.$store.dispatch("delCenterLabel", {
        relId: tag.relId,
        labelId: tag.labelId,
        centerId: this.centerId
      });
      if (code === "0") {
        this.detMemberMgt.labelInfoVos.splice(index, 1);
      }
    },
    pagingDetail(page) {
      this.currentPageDetail = page;
      this.queryDetailList();
    },
    handleSizeChangeDetail(size) {
      this.currentPageDetail = 1;
      this.pageSizeDetail = size;
      this.queryDetailList();
    },
    searchDetail() {
      this.currentPageDetail = 1;
      this.queryDetailList();
    },
    detailTypeChange() {
      this.detailList = [];
      this.currentPageDetail = 1;
      this.pageSizeDetail = 10;
      this.queryDetailList();
      this.$nextTick(() => {
        //解决表头与内容错位
        this.$refs.jindoutable.doLayout();
      });
    },
    async queryDetailList() {
      const params = {
        centerId: this.centerId,
        pageSize: this.pageSizeDetail,
        pageNo: this.currentPageDetail
      };
      const searchCondition = JSON.parse(
        JSON.stringify(this.searchConditionDialog)
      );
      Object.assign(params, searchCondition);
      let name =
        this.detailType === "data"
          ? "memberGoldBeanInfo"
          : "memberGoldBeanFlow";
      const { code, result } = await this.$store.dispatch(name, params);
      if (code === "0") {
        if (this.detailType === "data") {
          const { totalGoldBeanAmount, memberGoldBeanInfo } = result;
          this.totalGoldBeanAmount = totalGoldBeanAmount;
          this.detailList = memberGoldBeanInfo;
        } else {
          const { total, records } = result;
          records.forEach(v => {
            v.content =
              v.sendName + (v.specialName ? "(" + v.specialName + ")" : "");
          });
          this.detailList = records;
          this.totalDetail = total;
        }
      }
    },
    viewCustomerJinDou() {
      this.detailType = "data";
      this.dialogVisibleJinDou = true;
      this.currentPageDetail = 1;
      this.pageSizeDetail = 10;
      this.queryDetailList();
    },
    logout() {
      this.$confirm(" 是否确定注销?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let params = {
          centerId: this.centerId,
          memberMobile: this.detMemberMgt.storeMemberCenterInfoVo.memberMobile
        };

        this.$store.dispatch("memberCancel", params).then(res => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            this.dialogVisible = false;
            this.$emit("refresh", true);
          }
        });
      });
    },
    save() {
      let params = {
        defaultCardId: this.defaultCardId,
        centerId: this.centerId
      };

      // let actionName = "";
      // if (this.mode === "add" || this.mode === "addChild") {
      //   actionName = "addGoodsCategory";
      // } else if (this.mode === "edit") {
      //   actionName = "editMemberMgt";
      // }

      this.$store.dispatch("editMemberMgt", params).then(res => {
        if (res.code === "0") {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.dialogVisible = false;
          // this.queryList();
          this.$emit("refresh", true);
        }
      });
    },
    async addLabel() {
      this.innerVisible = true;
    },
    async queryDetails() {
      const { result } = await this.$store.dispatch("queryAllLabel", {
        centerId: this.centerId
      });
      this.allLabelList = result;
      this.$store
        .dispatch("detailsMemberMgt", {
          centerId: this.centerId
        })
        .then(res => {
          if (res.code == "0") {
            this.detMemberMgt = res.result;
            res.result.cardInfoVoList.forEach(v => {
              if (v.isMasterCard == "yes") {
                this.defaultCardId = v.memberCardId;
              }
            });
          }
        });
    },
    close() {
      this.$emit("close");
    },
    async saveLabel() {
      if (this.labelId !== "") {
        const { code } = await this.$store.dispatch("addLabelToCenter", {
          labelId: this.labelId,
          centerId: this.centerId
        });
        if (code === "0") {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.$store
            .dispatch("detailsMemberMgt", {
              centerId: this.centerId
            })
            .then(res => {
              if (res.code == "0") {
                this.labelId = "";
                this.detMemberMgt = res.result;
                res.result.cardInfoVoList.forEach(v => {
                  if (v.isMasterCard == "yes") {
                    this.defaultCardId = v.memberCardId;
                  }
                });
              }
            });
          this.innerVisible = false;
        }
      } else {
        this.$message({
          message: "请选择会员标签",
          type: "warning"
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.info-list {
  .title {
    margin-bottom: 20px;
    &::before {
      display: inline-block;
      margin-right: 10px;
      content: "";
      width: 4px;
      height: 12px;
      background: #e50065;
      border-top-left-radius: 30px;
      border-bottom-right-radius: 30px;
    }
  }
}
.cardid {
  margin-top: 23px;
}
.line {
  width: 1px;
  height: 40px;
  background: #ddd;
  margin: 0 80px;
}
</style>
